export default __webpack_public_path__ + "static/media/ic_sun_cloudy.1a7b446c.svg";